import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
// State
import { FollowupReasonsState } from '../_reducers/followup-reason.reducers';
import { selectReasonsState } from './reason.selectors';
import { FollowupReason } from '../_models/followup-reason.model';

export const selectFollowupReasonsState =
  createFeatureSelector<FollowupReasonsState>('FollowupReasons');

export const selectReasonById = (reasonId: number) =>
  createSelector(selectFollowupReasonsState, (reasonsState) => reasonsState.entities[reasonId]);

export const selectFollowupReasonsPageLoading = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => {
    return reasonsState.listLoading;
  },
);

export const selectFollowupReasonsActionLoading = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => reasonsState.actionsloading,
);

export const selectLastCreatedFollowupReasonId = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => reasonsState.lastCreatedFollowupReasonId,
);

export const selectLastCreatedFollowupReason = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => reasonsState.lastCreatedFollowupReason,
);

export const selectFollowupReasonsPageLastQuery = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => reasonsState.lastQuery,
);
export const selectFollowupReasonError = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => reasonsState.error,
);
export const selectFollowupReasonLatestSuccessfullAction = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => reasonsState.latestSuccessfullAction,
);
export const selectFollowupReasonsInStore = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => {
    const items = (reasonsState.ids as number[])
      .map((id) => reasonsState.entities[id])
      .filter((item): item is FollowupReason => item !== undefined);
    return new QueryResultsModel(items, reasonsState.totalCount);
  },
);

export const selectFollowupReasonsShowInitWaitingMessage = createSelector(
  selectFollowupReasonsState,
  (reasonsState) => reasonsState.showInitWaitingMessage,
);

export const selectHasReasonsInStore = createSelector(selectReasonsState, (queryResult) => {
  return queryResult.totalCount;
});
